import {Display} from "./Display";

export class Slider
{
    constructor(container)
    {
        const slides = container.querySelectorAll('.w__tile--book-cover');
        this.timeout = 5000;

        this.slides = [];
        for(let i=0; i<slides.length; i++)
        {
            this.slides[i] = slides[i];
        }

        if(this.slides.length > 2)
        {
            this.activeSlideNo = 0;
            setTimeout(() => { this.next_slide(); }, this.timeout);
        }
    }

    next_slide()
    {
        let newSlideNo = this.activeSlideNo + 2

        if(newSlideNo >= this.slides.length)
        {
            newSlideNo = 0;
        }

        this.slides[newSlideNo].querySelector('.w__tile--book-cover-img')
            ? this.switch_slide(newSlideNo)
            : this.load_slide(newSlideNo);
    }

    switch_slide(newSlideNo)
    {
        this.slides[this.activeSlideNo].classList.add('mod--out');
        this.slides[this.activeSlideNo + 1].classList.add('mod--out');
        this.slides[newSlideNo].classList.add('active');
        this.slides[newSlideNo + 1].classList.add('active');
        this.slides[newSlideNo].offsetHeight;
        this.slides[newSlideNo+ 1].offsetHeight;
        this.slides[newSlideNo].classList.remove('mod--in');
        this.slides[newSlideNo + 1].classList.remove('mod--in');

        setTimeout(() => {
            this.slides[this.activeSlideNo].classList.remove('active');
            this.slides[this.activeSlideNo + 1].classList.remove('active');
            this.slides[this.activeSlideNo].classList.remove('mod--out');
            this.slides[this.activeSlideNo + 1].classList.remove('mod--out');
            this.slides[this.activeSlideNo].classList.add('mod--in');
            this.slides[this.activeSlideNo + 1].classList.add('mod--in');
            this.activeSlideNo = newSlideNo;
            setTimeout(() => { this.next_slide(); }, this.timeout);
        },1000);
    }

    load_slide(newSlideNo, ready=false)
    {
        // create image
        const src = this.adjust_imagePath(this.slides[newSlideNo].dataset.image, this.slides[this.activeSlideNo].getBoundingClientRect()['width']),
              myImage = new Image;
        myImage.classList.add('w__tile--book-cover-img');
        myImage.src = src;
        myImage.alt = '';
        this.slides[newSlideNo].classList.add('mod--in');

        myImage.addEventListener('load',() =>
        {
            this.slides[newSlideNo].appendChild(myImage);
            (ready === true)
                ? this.switch_slide(newSlideNo - 1)
                : this.load_slide(newSlideNo + 1,true);
       });
    }

    adjust_imagePath(imgSrc, sizeX)
    {
        sizeX *= Display.dpi;

        let srcPath,
            targetPath;

        if(sizeX <= 228)
        {
            targetPath = '228x348';
        }
        else if(sizeX <= 380)
        {
            targetPath = '380x580';
        }
        else
        {
            targetPath = '570x870';
        }

        targetPath = '/' + targetPath + "/";
        srcPath = '/228x348/';

        return imgSrc.replace(srcPath, targetPath);
    }
}